import apiClient from '../../authentication/utils/core/axios';

const indexAPI = {
  // Get all indices
  fetchIndices: async (skip = 0, limit = 100) => {
    const res = await apiClient.get(`/indices?skip=${skip}&limit=${limit}`);
    if (res.status !== 200) throw new Error('Failed to fetch indices');
    return res.data;
  },

  // Get index details (with latest price and count)
  fetchIndexDetails: async (ticker) => {
    const res = await apiClient.get(`/indices/${ticker}`);
    if (res.status !== 200) throw new Error('Failed to fetch index details');
    return res.data;
  },

  // Get price history for an index
  fetchIndexPrices: async (ticker, { limit = 30, skip = 0 } = {}) => {
    const res = await apiClient.get(`/indices/${ticker}/prices?limit=${limit}&skip=${skip}`);
    if (res.status !== 200) throw new Error('Failed to fetch index prices');
    return res.data;
  },

  // Get metrics for an index
  fetchIndexMetrics: async (ticker) => {
    const res = await apiClient.get(`/indices/${ticker}/metrics`);
    if (res.status !== 200) throw new Error('Failed to fetch index metrics');
    return res.data;
  },

  // Manual refresh of index prices
  refreshIndexPrices: async (ticker, days = 30) => {
    const res = await apiClient.post(`/indices/${ticker}/refresh`, { days });
    if (res.status !== 200) throw new Error('Failed to refresh index prices');
    return res.data;
  }
};

export default indexAPI;
